import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminContext } from '../../../context/AdminContext';
import AdminLoadingScreen from '../shared/AdminLoadingScreen';

const ProtectedAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { sessionStatus } = useAdminContext();

  if (sessionStatus === 'loading') {
    return <AdminLoadingScreen label="Checking admin session..." />;
  }

  if (sessionStatus !== 'authenticated') {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default ProtectedAdminRoute;

